import naja from "naja";
import Sortable from 'sortablejs';
import 'slick-carousel';
// Styly slicku sem patří proto, že carousel týdnů je jediné místo, kde se slick používá.
import 'slick-carousel/slick/slick.css';

document.addEventListener('DOMContentLoaded', () => {
    const initPlan = $('.initPlan');
    if (!initPlan.length) {
        return;
    }

    const plan = new Plan();
    plan.init();

    // Odkazy s class="ajax" uvnitř plánu (odebrat team, vyčistit den, přepnout
    // týden, otevřít modal) by naja jinak poslala do adresního řádku i se
    // signálem `do=` a F5 by akci zopakovalo. Signály volané ručně přes
    // makeRequest mají `history: false` u sebe.
    naja.uiHandler.addEventListener('interaction', (event) => {
        if (event.detail.element.closest('.initPlan')) {
            event.detail.options.history = false;
        }
    });

    naja.addEventListener('complete', () => {
        plan.init();
    });
});

class Plan {
    init() {
        this.initSortableDay('users');
        this.initSortableDay('activities');
        this.initYearChange();
        this.initWeekSlick();
        this.initDoubleClick();
        this.initAllDaysCheckbox();
        this.initSortableTeams();
        this.changeUrl();
    }

    initSortableDay(selector) {
        const elDays = document.querySelectorAll('.day');
        elDays.forEach((el, index) => {
            this.initSortable(el.querySelector('.day-' + selector), el.querySelectorAll('.team-' + selector), 'group-' + selector + '-' + index, selector);
        });
    }

    // Signály plánu chodí s `history: false`. Naja jinak strčí URL signálu do
    // adresního řádku a F5 celou akci zopakuje - u přesunu pracovníka to znamená
    // druhé přiřazení, u mezitím smazaného dne rovnou 404. Adresu si hlídá
    // changeUrl(), která v ní drží jen `week` a `year`.
    initSortable(el, elList, group, selector) {
        // Uzavřený týden je jen archiv - přetahování se v něm vůbec neinicializuje.
        if (el && el.closest('.plan-readonly')) {
            return;
        }

        if (el && elList) {
            new Sortable(el, {
                group: group,
                draggable: '.btn',
                onMove(evt) {
                    if (evt.from === evt.to) {
                        return false
                    }
                },
                onEnd: function (/**Event*/ evt) {
                    if (evt.from === evt.to) {
                        return;
                    }
                    const itemEl = evt.item;

                    let url = evt.to.dataset.add.replace('=-1', '=' + itemEl.dataset.id);
                    if (typeof itemEl.dataset.type !== "undefined") {
                        url = url.replace('=-2', '=' + itemEl.dataset.type);
                    }

                    if (selector === 'activities'){
                        url = url.replace('=-2', '=' + evt.newDraggableIndex);
                    }

                    naja.makeRequest('GET', url, null, { history: false });
                },
            });

            elList.forEach((el) => {
                new Sortable(el, {
                    group: group,
                    draggable: '.btn',
                    onMove(evt) {
                        if (evt.from === evt.to && selector === 'users') {
                            return false
                        }
                    },
                    onEnd: function (/**Event*/ evt) {
                        if (evt.from === evt.to && selector === 'users') {
                            return;
                        }
                        const itemEl = evt.item;

                        if (evt.from.classList.contains('team-' + selector) && evt.to.classList.contains('team-' + selector)) {
                            let url = '';
                            if (evt.from === evt.to) {
                                 url = itemEl.dataset.move.replace('=-1', '=' + evt.newDraggableIndex);
                            }else{
                                url = evt.to.dataset.move.replace('=-1', '=' + itemEl.dataset.id).replace('=-2', '=' + evt.from.dataset.id);
                                if (typeof itemEl.dataset.type !== "undefined") {
                                    url = url.replace('=-3', '=' + itemEl.dataset.type);
                                }

                                if (selector === 'activities'){
                                    url = url.replace('=-3', '=' + evt.newDraggableIndex);
                                }
                            }

                            naja.makeRequest('GET', url, null, { history: false });
                        } else {
                            let url = evt.from.dataset.remove.replace('=-1', '=' + itemEl.dataset.id);
                            if (typeof itemEl.dataset.type !== "undefined") {
                                url = url.replace('=-2', '=' + itemEl.dataset.type);
                            }

                            naja.makeRequest('GET', url, null, { history: false });
                        }
                    },
                });
            });
        }
    }

    initSortableTeams() {
        const elDays = document.querySelectorAll('.teams');
        elDays.forEach((el, index) => {
            // V uzavřeném týdnu se pořadí týmů přehazovat nesmí.
            if (el.closest('.plan-readonly')) {
                return;
            }

            const sortable = new Sortable(el, {
                draggable: '.team-draggable',
                handle: '.team-handle',
                onEnd: function (/**Event*/ evt) {
                    naja.makeRequest('GET', evt.item.dataset.move.replace('=-1', '=' + evt.newIndex), null, { history: false });
                },
            });
        });
    }

    // replaceState, ne pushState: init() běží po každém AJAXu, takže pushState
    // přidával do historie záznam za záznamem. Tlačítko Zpět pak jen měnilo
    // adresu a rozpis zůstal stát na stejném týdnu.
    changeUrl() {
        const url = new URL(window.location.href);
        url.searchParams.set('week', $('.week-active').data('number'));
        url.searchParams.set('year', $('#year').val());
        window.history.replaceState(window.history.state, '', url);
    }

    // Select roku se AJAXem nepřekresluje, takže bez off() přibyl po každém
    // AJAXu další handler a jedna změna roku poslala N stejných requestů.
    // To pak shodilo LoopGuard a rozpis na 10 s nereagoval.
    initYearChange() {
        let self = this;
        $('#year').off('change.plan').on('change.plan', function () {
            naja.makeRequest('GET', $(this).data('change-link').replace('-year-', $(this).val()), null, { history: false });
            self.changeUrl();
        });
    }

    initWeekSlick() {
        let self = this;
        const slider = $('.weeks-slider');
        if (!slider.hasClass('slick-initialized')) {

            // console.log($('.week-link').index($('.week-active')));

            const node = document.querySelector('.week-active').parentNode;

            $('.week-list')

            slider.slick({
                initialSlide: Array.prototype.indexOf.call(node.parentNode.children, node),
                slidesToShow: 9,
                slidesToScroll: 5,
                focusOnSelect: true,
                prevArrow: '<button class="btn btn-sm prev"><i class="bi bi-chevron-left"></i></button>',
                nextArrow: '<button class="btn btn-sm next"><i class="bi bi-chevron-right"></i></button>',
                // infinite: true,
                infinite: false,
                centerMode: true,
                // responsive: [
                //     {
                //         breakpoint: 1024,
                //         settings: {
                //             slidesToShow: 10,
                //             slidesToScroll: 10,
                //             prevArrow: $('.bi-chevron-double-left'),
                //             nextArrow: $('.bi-chevron-double-right'),
                //         }
                //     }
                // ]

            });

            slider.slick('slickSetOption', 'slidesToScroll', 5, true);

            slider.on('click', 'a', function () {
                slider.find('a.is-actual').removeClass('btn-danger week-active').addClass('btn-outline-danger');
                slider.find('a.is-no-actual').removeClass('btn-primary week-active').addClass('btn-outline-primary');

                let color = $(this).hasClass('is-actual') ? 'danger' : 'primary';
                $(this).removeClass('btn-outline-primary btn-outline-danger').addClass('btn-' + color + ' week-active');

                $('.fixed-selected-kt').text('KT' + $('.week-active').data('number'));

                self.changeUrl();
            });
        }
    }

    initDoubleClick() {
        $('.btn-activity').off('dblclick').on('dblclick', function () {
            const editButton = $(this).find('.action-edit-btn').get(0);
            if (editButton) {
                naja.uiHandler.clickElement(editButton);
            }
        });

        $('.col-teams .btn-user').off('dblclick').on('dblclick', function () {
            // Dvojklik odebírá pracovníka z týmu - v archivu se nesmí vykonat.
            if (this.closest('.plan-readonly')) {
                return;
            }

            naja.makeRequest('GET', $(this).closest('.team-users').data('remove').replace('=-1', '=' + $(this).data('id')), null, { history: false });
        });
    }

    initAllDaysCheckbox() {
        $('input[name=allDays').off('click').on('click', function () {
            const checked = $(this).prop('checked');
            $('input[name^=days]').prop('checked', checked);
        });
    }
}
